import React from "react";
import { Box, Button, Container, Stack, Typography, Slide, useTheme } from "@mui/material";
import CookieIcon from "@mui/icons-material/Cookie";
import { useCookieConsent } from "../../hooks/useCookieConsent";

export const CookieBanner: React.FC = () => {
  const { bannerOpen, saveConsent, setSettingsOpen } = useCookieConsent();
  const theme = useTheme();

  const handleAcceptAll = () => {
    saveConsent({
      essential: true,
      analytics: true,
      marketing: true,
    });
  };

  const handleNecessaryOnly = () => {
    saveConsent({
      essential: true,
      analytics: false,
      marketing: false,
    });
  };

  return (
    <Slide direction="up" in={bannerOpen} mountOnEnter unmountOnExit>
      <Box
        role="region"
        aria-label="Cookie consent"
        sx={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 1300, // Above most things, below modals
          bgcolor: theme.palette.mode === "dark" ? "neutral.900" : "neutral.50",
          borderTop: 1,
          borderColor: "divider",
          boxShadow: theme.shadows[8],
          p: 3,
          pb: "max(24px, calc(24px + env(safe-area-inset-bottom)))",
        }}
      >
        <Container maxWidth="lg">
          <Stack
            direction={{ xs: "column", md: "row" }}
            spacing={3}
            alignItems={{ xs: "flex-start", md: "center" }}
            justifyContent="space-between"
          >
            <Stack direction="row" spacing={2} alignItems="flex-start">
              <CookieIcon color="primary" fontSize="large" sx={{ mt: 0.5 }} />
              <Box>
                <Typography variant="h6" component="p" fontWeight="bold" gutterBottom>
                  We value your privacy
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 600 }}>
                  We use cookies to enhance your browsing experience, serve personalized content,
                  and analyze our traffic. By clicking "Accept All", you consent to our use of
                  cookies.
                </Typography>
              </Box>
            </Stack>
            <Stack
              direction={{ xs: "column", sm: "row" }}
              spacing={2}
              sx={{ width: { xs: "100%", md: "auto" } }}
            >
              <Button
                variant="outlined"
                color="inherit"
                onClick={() => setSettingsOpen(true)}
                sx={{ whiteSpace: "nowrap" }}
              >
                Customize
              </Button>
              <Button
                variant="outlined"
                color="primary"
                onClick={handleNecessaryOnly}
                sx={{ whiteSpace: "nowrap" }}
              >
                Necessary Only
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={handleAcceptAll}
                sx={{ whiteSpace: "nowrap" }}
              >
                Accept All
              </Button>
            </Stack>
          </Stack>
        </Container>
      </Box>
    </Slide>
  );
};
